import Dexie from 'dexie'

const db = new Dexie('SearchGullDB')
db.version(1).stores({ searches: '++id' })

export default db


// WEBPACK FOOTER //
// ./src/components/db.js